import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'mainPage',
    component: () => import('../views/mainPage/mainPage.vue')//首页
  },
  {
    path: '/swiperDetail',
    name: 'swiperDetail',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/mainPage/swiperDetail.vue'),//轮播详情
  },
  {
    path: '/agemnt',
    name: 'agemnt',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/agment/agment.vue'),//协议
  },
  {
    path: '/allCourses',
    name: 'allCourses',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/allCourses/allCourses.vue'),//全部课程
  },
  {
    path: '/searchResult',
    name: 'searchResult',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/searchResult/searchResult.vue'),//搜索结果
  },
  {
    path: '/member',
    name: 'member',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/member/member.vue'),//会员中心
  },
  {
    path: '/memberQuanyi',
    name: 'memberQuanyi',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/member/memberQuanyi.vue'),//会员权益
  },
  {
    path: '/minePage',
    name: 'minePage',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/minePage/minePage.vue'),//个人中心
  },
  {
    path: '/publicAgement',
    name: 'publicAgement',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/minePage/publicAgement.vue'),//公告协议
  },
  {
    path: '/message',
    name: 'message',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/minePage/message.vue'),//消息通知
  },
  {
    path: '/courseDetail',
    name: 'courseDetail',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/courseDetail/courseDetail.vue'),//课程详情
  }
]

const router = new VueRouter({
  mode: 'hash',//hash history
  base: process.env.BASE_URL,
  routes
})
// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 检查目标路由是否与当前路由相同（包括查询参数和哈希）
  if (to.path === from.path && to.query === from.query && to.hash === from.hash) {
    // 如果相同，则不执行跳转，可以显示一个提示或者做其他处理
    alert('Cannot navigate to the same route.');
    next(false); // 阻止导航
  } else {
    // 如果不同，则允许导航
    next();
  }
});

export default router
